import { useQuery } from 'react-query';
import { auth } from '~/api/axios';
import { getProfiles } from '~/api/onboarding';

const useCurrentProfile = () => {
  // Get current business id.
  const businessId = auth.getProfile();
  // Get profiles and find the current business.
  const { data } = useQuery('profiles', () => getProfiles().then((res) => res.data))
  return data?.find(profile => profile.id === businessId)
}

export default useCurrentProfile

